import {useNavigate, useSearchParams} from "react-router-dom";
import {shiftSelector, useGetShiftQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {useTranslation} from "react-i18next";
import {ShiftMap} from "../../components/profile/ShiftProfile/ShiftMap";
import {ProtectedPage} from "../../components/page/ProtectedPage/ProtectedPage";

type Props = {
  id?: string;
  database?: string
}

export const ShiftLocationHistoryMapPageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;
  const database = params.get("database") ?? undefined;

  const {t} = useTranslation(["common"])

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.shift", "Shift") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ShiftLocationHistoryMapPage id={id} database={database}/>;
};

export const ShiftLocationHistoryMapPage = (props: Props) => {
  const {id} = props;

  const {t} = useTranslation(["common"])

  const [access, setAccess] = useState(false);

  const selectShift = useMemo(() => {
    return shiftSelector()
  }, []);

  const {shift, loading} = useGetShiftQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      shift: selectShift(result),
      loading: result.isFetching
    })
  });

  const error = !shift ? t<string>("common.error.notfound", "Not Found") : undefined

  return (
    <ProtectedPage
      permissions={["shift_view"]}
      isLoading={loading}
      error={error}
      onAccess={setAccess}>
      <ShiftMap shift={shift}/>
    </ProtectedPage>
  );
};
